import { createContext, useContext, useState } from 'react';
import { useLocationTracking } from '../hooks/useLocationTracking';

// Lifts tracking state OUT of the Map screen and into a context that
// lives for the whole app session. This is what lets:
//   1. The tab bar's pulse indicator show correctly on EVERY screen,
//      not just while Map.js happens to be mounted
//   2. The actual WebSocket + GPS connection keep running in the
//      background while the driver checks Payments, Profile, etc.
//   3. The Map screen access "heading" (direction of travel) for the
//      driving-mode rotation + truck icon rotation features
const TrackingContext = createContext(null);

export function TrackingProvider({ children }) {
  const [trackingEnabled, setTrackingEnabled] = useState(false);
  const { isConnected, currentPosition, heading } = useLocationTracking(trackingEnabled);

  return (
    <TrackingContext.Provider
      value={{ trackingEnabled, setTrackingEnabled, isConnected, currentPosition, heading }}
    >
      {children}
    </TrackingContext.Provider>
  );
}

export function useTracking() {
  const context = useContext(TrackingContext);
  if (!context) {
    throw new Error('useTracking must be used within a TrackingProvider');
  }
  return context;
}